import { useQuery } from "@tanstack/react-query";

import { appQueryKeys } from "@/app/data/appQueryKeys";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { OnboardingStatusDTO } from "@reflag/shared/onboardingAPI";

export function useOnboardingStatusData(options?: {
  enabled?: boolean;
  poll?: boolean;
}) {
  const { appId } = useEnvironment();
  const queryEnabled = !!appId && options?.enabled !== false;
  const shouldPoll = options?.poll !== false;

  return useQuery({
    queryKey: appQueryKeys.onboardingStatus(appId),
    queryFn: () =>
      api
        .get<"/apps/:appId/onboarding-status">(
          `/apps/${appId}/onboarding-status`,
        )
        .then((res) => res.data),
    enabled: queryEnabled,
    refetchInterval(query) {
      if (!shouldPoll) {
        return false;
      }
      const data = query.state.data as OnboardingStatusDTO | undefined;
      return data?.hasSdkActivity ? false : 1000;
    },
  });
}
